module.exports = __webpack_public_path__ + "static/logo2-0571cea008230e4ecd611f8b5a19c54a.png";